import { createApi } from "@reduxjs/toolkit/query/react";
import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";
import { transformResponseHandler } from "utils/transformResponseHandler";
import { customFetchBase } from ".";

const masterApi = createApi({
  reducerPath: REDUCER_PATHS.MASTER,
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    /************
     * Territory Api
     *************/

    territoryListData: builder.query({
      query: () => ({
        url: `${apiConfig.TERRITORY_DROPDOWN}`,
        method: "GET",
      }),
    }),
    addEditTerritory: builder.mutation({
      query: (data) => ({
        url: apiConfig.MASTER_ADD_TERRITORY,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    territoryListing: builder.query({
      query: (data) => ({
        url: `${apiConfig.MASTER_ADD_TERRITORY}?page=${data?.page}&pageSize=${data?.pageSize}&searchText=${data?.searchText}&sortColumn=${data?.sortColumn}&sortDirection=${data?.sortDirection}`,
        method: "GET",
      }),
      providesTags: ["territory"],
    }),
    deleteTerritory: builder.mutation({
      query: (data) => ({
        url: apiConfig.MASTER_ADD_TERRITORY,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    changeTerritoryStatus: builder.mutation({
      query: (data) => ({
        url: apiConfig.MASTER_ADD_TERRITORY,
        body: data,
        method: "PATCH",
      }),
      invalidatesTags: ["territory"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    detailsTerritory: builder.query({
      query: (data) => ({
        url: `${apiConfig.MASTER_ADD_TERRITORY}/${data.id}`,
        method: "GET",
      }),
    }),

    /************
     * Etiology Api
     *************/
    addEditEtiology: builder.mutation({
      query: (data) => ({
        url: apiConfig.MASTER_ETIOLOGY,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    etiologyListing: builder.query({
      query: (data) => ({
        url: `${apiConfig.MASTER_ETIOLOGY}?page=${data?.page}&pageSize=${data?.pageSize}&searchText=${data?.searchText}&sortColumn=${data?.sortColumn}&sortDirection=${data?.sortDirection}`,
        method: "GET",
      }),
      providesTags: ["etiology"],
    }),
    deleteEtiology: builder.mutation({
      query: (data) => ({
        url: apiConfig.MASTER_ETIOLOGY,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    changeEtiologyStatus: builder.mutation({
      query: (data) => ({
        url: apiConfig.MASTER_ETIOLOGY,
        body: data,
        method: "PATCH",
      }),
      invalidatesTags: ["etiology"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    detailsEtiology: builder.query({
      query: (data) => ({
        url: `${apiConfig.MASTER_ETIOLOGY}/${data.id}`,
        method: "GET",
      }),
    }),
    etiologyListData: builder.query({
      query: () => ({
        url: `/admin/dropdown/etiologies`,
        method: "GET",
      }),
    }),
    /************
     * Professional Designation
     *************/
    designationListData: builder.query({
      query: () => ({
        url: `/admin/dropdown/designations`,
        method: "GET",
      }),
    }),
    addEditDesignation: builder.mutation({
      query: (data) => ({
        url: apiConfig.MASTER_ADD_DESIGNATION,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    designationListing: builder.query({
      query: (data) => ({
        url: `${apiConfig.MASTER_ADD_DESIGNATION}?page=${data?.page}&pageSize=${data?.pageSize}&searchText=${data?.searchText}&sortColumn=${data?.sortColumn}&sortDirection=${data?.sortDirection}`,
        method: "GET",
      }),
      providesTags: ["designation"],
    }),
    deleteDesignation: builder.mutation({
      query: (data) => ({
        url: apiConfig.MASTER_ADD_DESIGNATION,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    changeDesignationStatus: builder.mutation({
      query: (data) => ({
        url: apiConfig.MASTER_ADD_DESIGNATION,
        body: data,
        method: "PATCH",
      }),
      invalidatesTags: ["designation"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    detailsDesignation: builder.query({
      query: (data) => ({
        url: `${apiConfig.MASTER_ADD_DESIGNATION}/${data.id}`,
        method: "GET",
      }),
    }),
    facilityList: builder.query({
      query: () => ({
        url: "/admin/dropdown/facility",
        method: "Get",
      }),
      invalidatesTags: ["patient"],
      // transformResponse: (resp) => transformResponseHandler(resp),
    }),
    /************
     * PAGE TITLE
     *************/

    addPageTitle: builder.mutation({
      query: (data) => ({
        url: apiConfig.MASTER_ADD_PAGE_TITLE,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    pageTitleListing: builder.query({
      query: (data) => ({
        url: `${apiConfig.MASTER_ADD_PAGE_TITLE}?page=${data?.page}&pageSize=${data?.pageSize}&searchText=${data?.searchText}&sortColumn=${data?.sortColumn}&sortDirection=${data?.sortDirection}`,
        method: "GET",
      }),
      providesTags: ["pageTitle"],
    }),
    deletePageTitle: builder.mutation({
      query: (data) => ({
        url: apiConfig.MASTER_ADD_PAGE_TITLE,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    changePageTitleStatus: builder.mutation({
      query: (data) => ({
        url: apiConfig.MASTER_ADD_PAGE_TITLE,
        body: data,
        method: "PATCH",
      }),
      invalidatesTags: ["pageTitle"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    detailsPageTitle: builder.query({
      query: (data) => ({
        url: `${apiConfig.MASTER_ADD_PAGE_TITLE}/${data.id}`,
        method: "GET",
      }),
    }),
    // page Title Dropdown List
    pageTitleDropdown: builder.query({
      query: () => ({
        url: "/admin/dropdown/question_pages",
        method: "Get",
      }),
    }),
    pageTilteSwap: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.MASTER_ADD_PAGE_TITLE}/swap`,
        body: data,
        method: "PATCH",
      }),
      invalidatesTags: ["pageTitle"],
      // transformResponse: (resp) => transformResponseHandler(resp),
    }),

    anatomicListData: builder.query({
      query: () => ({
        url: `admin/dropdown/anatomic_locations`,
        method: "GET",
      }),
    }),
    appUserListData: builder.query({
      query: () => ({
        url: `${apiConfig.APP_USER_DROPDOWN}`,
        method: "GET",
      }),
    }),
    patientListData: builder.query({
      query: () => ({
        url: `${apiConfig.PATIENTS_DROPDOWN}`,
        method: "GET",
      }),
    }),

    /************
     * Not Assess Reason
     *************/
    addEditNotAssessReason: builder.mutation({
      query: (data) => ({
        url: apiConfig.NOT_ASSESS_REASON,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    notAssessReasonListing: builder.query({
      query: (data) => ({
        url: `${apiConfig.NOT_ASSESS_REASON}?page=${data?.page}&pageSize=${data?.pageSize}&searchText=${data?.searchText}&sortColumn=${data?.sortColumn}&sortDirection=${data?.sortDirection}`,
        method: "GET",
      }),
      providesTags: ["etiology"],
    }),
    deleteNotAssessReason: builder.mutation({
      query: (data) => ({
        url: apiConfig.NOT_ASSESS_REASON,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    changeNotAssessReasonStatus: builder.mutation({
      query: (data) => ({
        url: apiConfig.NOT_ASSESS_REASON,
        body: data,
        method: "PATCH",
      }),
      invalidatesTags: ["etiology"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    detailsNotAssessReason: builder.query({
      query: (data) => ({
        url: `${apiConfig.NOT_ASSESS_REASON}/${data.id}`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useAddEditTerritoryMutation,
  useLazyTerritoryListingQuery,
  useDeleteTerritoryMutation,
  useChangeTerritoryStatusMutation,
  useLazyDetailsTerritoryQuery,
  useAddEditEtiologyMutation,
  useLazyEtiologyListingQuery,
  useDeleteEtiologyMutation,
  useChangeEtiologyStatusMutation,
  useEtiologyListDataQuery,
  useLazyDetailsEtiologyQuery,
  useAddEditDesignationMutation,
  useLazyDesignationListingQuery,
  useDeleteDesignationMutation,
  useChangeDesignationStatusMutation,
  useLazyDetailsDesignationQuery,
  useTerritoryListDataQuery,
  useLazyTerritoryListDataQuery,
  useDesignationListDataQuery,
  useFacilityListQuery,
  useLazyDesignationListDataQuery,
  //pageTitle
  useAddPageTitleMutation,
  useLazyPageTitleListingQuery,
  useChangePageTitleStatusMutation,
  useDeletePageTitleMutation,
  useLazyDetailsPageTitleQuery,
  useLazyPageTitleDropdownQuery,
  usePageTilteSwapMutation,
  //anatomic Location
  useAnatomicListDataQuery,
  useAppUserListDataQuery,
  usePatientListDataQuery,
  //not assess reason
  useLazyNotAssessReasonListingQuery,
  useAddEditNotAssessReasonMutation,
  useDeleteNotAssessReasonMutation,
  useChangeNotAssessReasonStatusMutation,
  useLazyDetailsNotAssessReasonQuery,
} = masterApi;

export default masterApi;
